import { Heart } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      {/* Header */}
      <header className="bg-white border-b border-border sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center gap-2 text-primary">
              <Heart weight="fill" className="w-7 h-7" />
              <span className="text-xl font-bold font-[Manrope]">MEDICULDIGITAL</span>
            </Link>
            <Link 
              to="/register" 
              className="text-sm text-muted-foreground hover:text-primary transition-colors"
            >
              ← Înapoi la înregistrare
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <article className="prose prose-slate max-w-none">
          <h1 className="text-3xl font-bold font-[Manrope] text-foreground mb-8">
            Termeni de Utilizare NCS LLC USA
          </h1>
          
          <p className="text-muted-foreground mb-6">
            <strong>Ultima actualizare:</strong> 24 iunie 2026<br />
            <strong>Data intrării în vigoare:</strong> 01 iulie 2026
          </p>

          <p>
            Bun venit și vă mulțumim că utilizați NCS LLC USA. Vă rugăm să citiți cu atenție Termenii de Utilizare NCS (denumiți în continuare: „Termenii"). Termenii guvernează accesul și utilizarea de către dvs. a conținutului, serviciilor, soluțiilor și tehnologiilor NCS, protejate prin înregistrarea la OSIM pentru teritoriul României și al UE (denumite colectiv: „Serviciul").
          </p>

          <p>
            NCS este o denumire comercială, o companie înregistrată în UNITED STATES OF AMERICA (număr de înregistrare comercială 517319190), cu sediul înregistrat la: NETWORK CONSULTANCY SERVICES LLC – NCS LLC, companie înregistrată în Statele Unite ale Americii, Delaware 1995816192, cu sediul în 16192 Coastal Highway, Lewes.
          </p>

          <h2 className="text-xl font-semibold mt-8 mb-4">1. Definiții</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Politica de utilizare acceptabilă:</strong> Politica NCS LLC care face parte integrantă din Termeni.</li>
            <li><strong>Informații despre cont:</strong> Informații furnizate pentru crearea, administrarea sau menținerea Contului (nume, parolă, e-mail, plăți).</li>
            <li><strong>Afiliat:</strong> Orice entitate care controlează sau este controlată de o parte (peste 50% drepturi de vot).</li>
            <li><strong>Conținutul Clientului:</strong> Informații sau materiale introduse în Serviciu.</li>
            <li><strong>Documentația:</strong> Ghidul de utilizare furnizat direct de NCS.</li>
            <li><strong>Feedback:</strong> Sugestii, idei și îmbunătățiri furnizate către NCS.</li>
            <li><strong>Taxe de serviciu:</strong> Prețul aplicabil pentru pachetul ales.</li>
            <li><strong>Informații personale sensibile:</strong> Date de sănătate (HIPAA), conturi financiare, numere de identificare guvernamentale.</li>
            <li><strong>Perioada de abonament:</strong> Durata pentru care s-a contractat Serviciul.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">2. Înregistrarea Contului NCS LLC</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Înregistrare și licență:</strong> Trebuie să furnizați informații exacte pentru a accesa Serviciul. Licența este limitată la uz intern și profesional.</li>
            <li><strong>Eligibilitate:</strong> Trebuie să aveți capacitatea legală de a încheia contracte.</li>
            <li><strong>Credențiale de acces:</strong> Sunteți responsabil pentru confidențialitatea parolelor. Orice utilizare neautorizată trebuie raportată imediat.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">3. Taxe de serviciu; Perioada și încetarea</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Taxe:</strong> Serviciile din perioada de încercare sunt „CA ATARE". Taxele nu includ impozite locale.</li>
            <li><strong>Abonament și reînnoire:</strong> Se reînnoiește automat la finalul perioadei, dacă nu este anulat.</li>
            <li><strong>Anulare:</strong> Se face prin chat-ul din aplicație. Anularea nu dă dreptul la rambursări pentru perioada neutilizată.</li>
            <li><strong>Efectul încetării:</strong> Datele pot fi șterse după 12 luni de inactivitate.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">4. Utilizarea Serviciului și restricții</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Utilizare interzisă:</strong> Este interzisă revânzarea, ingineria inversă, copierea, testele de securitate sau dezvoltarea unui produs concurent.</li>
            <li><strong>Date sensibile:</strong> Este strict interzisă încărcarea de Informații personale sensibile fără consimțământ.</li>
            <li><strong>Aplicare:</strong> NCS poate monitoriza Serviciul și șterge Conținutul Clientului în caz de încălcare a Termenilor.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">5. Proceduri de securitate și confidențialitate</h2>
          <p>Se aplică Politica de Confidențialitate NCS LLC. Dacă NCS prelucrează date cu caracter personal, se aplică Acordul de prelucrare a datelor (DPA).</p>

          <h2 className="text-xl font-semibold mt-8 mb-4">6. Termeni aplicabili datelor dvs.</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Proprietate:</strong> Clientul păstrează proprietatea asupra datelor sale. NCS primește o licență limitată doar pentru a furniza, menține și îmbunătăți Serviciul.</li>
            <li><strong>AI:</strong> NCS nu utilizează conținutul clientului pentru a antrena modele AI de uz general pentru terți.</li>
            <li><strong>Obligații:</strong> Clientul garantează că are drepturile legale pentru datele transmise.</li>
          </ul>

          <h2 className="text-xl font-semibold mt-8 mb-4">7. Drepturi de proprietate</h2>
          <p>NCS deține toate drepturile asupra Serviciului, actualizărilor și lucrărilor derivate. Feedback-ul oferit poate fi utilizat de NCS fără compensații.</p>

          <h2 className="text-xl font-semibold mt-8 mb-4">8. Garanții și despăgubiri</h2>
          <p><strong>Excluderi (Disclaimer):</strong> SERVICIUL ESTE FURNIZAT „CA ATARE". NCS exclude orice garanție de comercializare sau adecvare pentru un scop anume.</p>

          <h2 className="text-xl font-semibold mt-8 mb-4">9. Limitarea răspunderii</h2>
          <p>NCS nu va fi răspunzătoare pentru daune indirecte, pierderi de profit, de date sau de bunăvoință. Răspunderea totală a NCS este limitată la valoarea taxelor plătite de client în perioada curentă de abonament.</p>

          <h2 className="text-xl font-semibold mt-8 mb-4">10. Confidențialitate</h2>
          <p>Părțile se obligă să protejeze informațiile confidențiale marcate ca atare sau care, prin natura lor, sunt confidențiale.</p>

          <hr className="my-8" />
          <p className="text-sm text-muted-foreground">© 2026 NCS LLC Legal. All rights reserved.</p>
        </article>
      </main>
    </div>
  );
}
